module.exports = __webpack_public_path__ + "img/2-1.53887f80.png";